import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      keepPreviousData: true,
      retry: 0,
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
    },
    mutations: {
      retry: 0,
      useErrorBoundary: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error: any, variables, context, mutation) => {
      // If a mutation has a local `onError` (e.g. in `useMutation`), don't show the global toast.
      // This prevents duplicate error handling.
      const mutationAny = mutation as any;
      const hasLocalOnError =
        typeof mutationAny?.options?.onError === "function" ||
        (typeof mutationAny?.getObservers === "function" &&
          mutationAny.getObservers().some((observer: any) => typeof observer?.options?.onError === "function"));

      console.log({ hasLocalOnError });
      if (hasLocalOnError) return;

      const errorMessage = error?.response?.data?.error ?? error?.message;
      console.log({ errorMessage });

      toast.error(errorMessage);
    },
  }),
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      // If a query has a local `onError` (e.g. in `useQuery`), don't show the global toast.
      // This prevents duplicate error handling.
      const queryAny = query as any;
      const hasLocalOnError =
        typeof queryAny?.options?.onError === "function" ||
        (typeof queryAny?.getObservers === "function" &&
          queryAny.getObservers().some((observer: any) => typeof observer?.options?.onError === "function"));

      if (hasLocalOnError) return;

      const errorMessage = error?.response?.data?.error ?? error?.message;
      toast.error(errorMessage);
    },
  }),
});

export const getRelatedCacheKeys = (queryClient: QueryClient, targetKey: string) => {
  return queryClient
    .getQueryCache()
    .getAll()
    .map((query) => query.queryKey)
    .filter((queryKey) => queryKey[0] === targetKey);
};
